export enum RaterType {
  DRIVER = "driver",
  RIDER = "rider",
}

export enum ReportReason {
  INAPPROPRIATE_LANGUAGE = "inappropriate-language",
  FALSE_INFORMATION = "false-information",
  SPAM = "spam",
  HARASSMENT = "harassment",
  DISCRIMINATION = "discrimination",
  OTHER = "other",
}

export enum RatingStars {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
}